<template>
	<div class="title" style="width: 100%; height: 85vh; overflow-y: auto">
		<div class="roboto">
			<div class="title">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ $t("download-your-data") }}</h1>
					</div>
				</div>
			</div>
			<div style="width: 100%">
				<div style="width: 55%; margin-left: auto; margin-right: auto; overflow-y: auto; padding: 15px">
					<p>{{ $t("download-your-data-description") }}</p>
					<el-button @click="downloadRequest" type="primary" :loading="download">{{ $t("send") }}</el-button>
				</div>
			</div>
		</div>
		<hr />
		<div class="roboto">
			<div class="title">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ $t("request-oblivion") }}</h1>
					</div>
				</div>
			</div>
			<div style="width: 100%">
				<div style="width: 55%; margin-left: auto; margin-right: auto; overflow-y: auto; padding: 15px">
					<p>{{ $t("oblivion-description") }}</p>
					<el-button
						v-if="!user.organization.request_of_deletion"
						@click="nukeRequest"
						type="primary"
						:loading="obliv"
						>{{ $t("send") }}</el-button
					>
					<el-button v-else @click="nukeRequest" disabled>{{ $t("already-requested") }}</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from "axios"
import { mapGetters } from "vuex"

export default {
	name: "YourData",
	data() {
		return {
			height: window.innerHeight / 2 - 200,
			download: false,
			obliv: false
		}
	},
	computed: {
		...mapGetters({
			user: "user/user"
		})
	},
	methods: {
		downloadRequest() {
			this.download = true
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/requestData",
					{},
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {
					this.download = false
					this.downloads(JSON.stringify(res.data, null, 2), "data.txt", "text/plain")
				})
				.catch(err => {
					this.$notification("error", this.$t("contact-notification-error"), "", 0)
					this.download = false
				})
		},
		downloads(content, fileName, contentType) {
			var a = document.createElement("a")
			var file = new Blob([content], { type: contentType })
			a.href = URL.createObjectURL(file)
			a.download = fileName
			a.click()
		},

		nukeRequest() {
			this.obliv = true
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/requestNuke",
					{},
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {
					this.$notification("success", this.$t("oblivion-success"), "", 4500)
					this.obliv = false
				})
				.catch(err => {
					this.$notification("error", this.$t("contact-notification-error"), "", 0)
					this.obliv = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-form";

h3 {
	font-family: "Montserrat", sans-serif;
}

.roboto {
	font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
</style>
